import React from 'react';
import { Divider as DividerComponent } from '@mui/material';
export const Divider = ({ children, absolute = false, orientation = 'vertical', variant = 'Primary', weight = 2, flexItem = false, _sx = {}, className = '', dataTestId, }) => {
    const borderWidth = orientation === 'vertical'
        ? `0px ${weight}px 0px 0px`
        : `0px 0px ${weight}px 0px`;
    return (React.createElement(DividerComponent, { className: className, absolute: absolute, variant: variant, orientation: orientation, sx: Object.assign({ borderWidth }, _sx), flexItem: flexItem, "data-testid": dataTestId }, children));
};
